import React, { Component } from "react";
import { Modal, Input, Button, Radio, Select, Form } from "antd";

class ModalNoDeal extends Component {
  state = {
    checkButtonSend: false,
    customerVerification: true,
    notes: null,
    noDealNotes: null,
  };

  // ************************* Function Change Data *************************//
  checkButtonSendNoDeal() {
    const { customerVerification, noDealNotes, notes } = this.state;
    if (![customerVerification, noDealNotes, notes].includes(null)) {
      this.setState({ checkButtonSend: true });
    } else {
      this.setState({ checkButtonSend: false });
    }
  }

  changeCustomerVerification(e) {
    this.setState({ customerVerification: e.target.value }, () =>
      this.checkButtonSendNoDeal()
    );
    this.checkButtonSendNoDeal();
  }

  changeReasonNoDeal(val) {
    this.setState({ noDealNotes: val }, () => this.checkButtonSendNoDeal());
  }

  changeNotesNoDeal(e) {
    this.setState({ notes: e.target.value }, () =>
      this.checkButtonSendNoDeal()
    );
  }

  emptyState() {
    this.setState({
      notes: null,
      noDealNotes: null,
      customerVerification: true,
      checkButtonSend: false,
    });
  }

  // ************************* Function Send Button *************************//
  async sendNoDealButton() {
    const { customerVerification, notes, noDealNotes } = this.state;
    const data = {
      customerVerification,
      deal: false,
      noDealNotes,
      notes,
      finalPrice: null,
    };
    this.setState({ loadingButton: true });
    await this.props.sendButton(data);
    this.emptyState();
    this.setState({ loadingButton: false });
    this.props.visibleModal("No Deal", false);
  }

  render() {
    const defaultValue = this.props.reason
      ? this.props.reason.length > 0
        ? this.props.reason[0].name
        : null
      : null;
    return (
      <Modal
        footer={[null]}
        title="Alasan Penolakan"
        visible={this.props.visible}
        onCancel={() => {
          this.props.visibleModal("No Deal", false), this.emptyState();
        }}
      >
        <Form.Item label="Apakah customer tetap membeli mobil di AUTO2000?">
          <Radio.Group
            value={this.state.customerVerification}
            onChange={v => this.changeCustomerVerification(v)}
          >
            <Radio value={true}>Ya</Radio>
            <Radio value={false}>Tidak</Radio>
          </Radio.Group>
        </Form.Item>
        <Form.Item label="Alasan Tidak Deal">
          <Select
            style={{ width: "100%" }}
            size="large"
            onChange={v => this.changeReasonNoDeal(v)}
          >
            {this.props.reason
              ? this.props.reason.map((v, i) => (
                  <Select.Option value={v.name} key={i}>
                    {v.name}
                  </Select.Option>
                ))
              : null}
          </Select>
        </Form.Item>
        <Form.Item label="Notes">
          <Input.TextArea
            value={this.state.notes}
            rows={4}
            onChange={v => this.changeNotesNoDeal(v)}
          />
        </Form.Item>
        <Button
          block
          disabled={this.state.checkButtonSend ? false : true}
          loading={this.state.loadingButton}
          size="large"
          type="primary"
          onClick={() => this.sendNoDealButton()}
        >
          KIRIM
        </Button>
      </Modal>
    );
  }
}

export default ModalNoDeal;



// WEBPACK FOOTER //
// src/components/Dashboard/Approval/Component/Modal/ModalNoDeal.js